import styled from 'styled-components';

export const CookieConsentWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #2F4F4F 0%, #1c3333 100%);
  color: white;
  z-index: 9999;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
  border-top: 3px solid #D2A46E;
  animation: slideUp 0.5s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    bottom: auto;
    border-top: none;
    border-bottom: 3px solid #D2A46E;
    animation: slideDown 0.5s ease-out;
  }

  @keyframes slideDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

export const CookieConsentContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    padding: 15px;
  }
`;

export const CookieIcon = styled.div`
  color: #D2A46E;
  font-size: 2.5rem;
  flex-shrink: 0;

  svg {
    font-size: 2.5rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    svg {
      font-size: 2rem;
    }
  }
`;

export const CookieText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CookieTitle = styled.h3`
  color: #D2A46E;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 10px 0;
  font-family: 'Rubik', sans-serif;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const CookieDescription = styled.p`
  color: #E8E8E8;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;

  strong {
    color: #D2A46E;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

export const CookieButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    
    button {
      flex: 1;
      min-width: 120px;
    }
  }

  @media (max-width: 480px) {
    flex-direction: column;
    
    button {
      width: 100%;
    }
  }
`;

export const AcceptButton = styled.button`
  background: #D2A46E;
  color: #2F4F4F;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: #B8935A;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(210, 164, 110, 0.4);
  }

  svg {
    font-size: 1.1rem;
  }
`;

export const DeclineButton = styled.button`
  background: transparent;
  color: #E8E8E8;
  border: 2px solid #666;
  padding: 12px 20px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    border-color: #D2A46E;
    color: #D2A46E;
    background: rgba(210, 164, 110, 0.1);
  }
`;

export const SettingsButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  color: #E8E8E8;
  border: 2px solid rgba(255, 255, 255, 0.2);
  padding: 12px 20px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: #D2A46E;
    color: #D2A46E;
  }

  svg {
    font-size: 1.1rem;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  left: 15px;
  background: transparent;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    color: #D2A46E;
    background: rgba(210, 164, 110, 0.1);
  }

  svg {
    font-size: 1.2rem;
  }

  @media (max-width: 768px) {
    top: 10px;
    left: 10px;
  }
`;

// Modal Styles
export const CookieModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.3s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: slideInModal 0.3s ease-out;

  @keyframes slideInModal {
    from {
      transform: scale(0.9) translateY(20px);
      opacity: 0;
    }
    to {
      transform: scale(1) translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalHeader = styled.div`
  padding: 25px 25px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 20px;

  h3 {
    color: #2F4F4F;
    font-size: 1.4rem;
    font-weight: 700;
    margin: 0;
    padding-bottom: 15px;
  }

  button {
    position: relative;
    top: -10px;
    color: #666;
  }
`;

export const ModalBody = styled.div`
  padding: 0 25px;
`;

export const CookieCategory = styled.div`
  margin-bottom: 25px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border-right: 4px solid #D2A46E;
`;

export const CategoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  h4 {
    color: #2F4F4F;
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
  }
`;

export const CategoryDescription = styled.p`
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
`;

export const ToggleSwitch = styled.div`
  position: relative;
  width: 60px;
  height: 30px;
  background: ${props => props.checked ? '#D2A46E' : '#ccc'};
  border-radius: 15px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background 0.3s ease;
  display: flex;
  align-items: center;
  padding: 0 5px;
  opacity: ${props => props.disabled ? 0.6 : 1};

  &:before {
    content: '';
    position: absolute;
    width: 22px;
    height: 22px;
    background: white;
    border-radius: 50%;
    transform: translateX(${props => props.checked ? '30px' : '0'});
    transition: transform 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  span {
    font-size: 0.75rem;
    font-weight: 500;
    color: ${props => props.checked ? 'white' : '#666'};
    margin-right: ${props => props.checked ? '5px' : '25px'};
    transition: all 0.3s ease;
  }
`;

export const ModalButtons = styled.div`
  padding: 20px 25px 25px;
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  border-top: 1px solid #eee;
  margin-top: 20px;

  @media (max-width: 480px) {
    flex-direction: column;
    
    button {
      width: 100%;
    }
  }
`;
